module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('v-card', {
    attrs: {
      "tile": ""
    }
  }, [_c('v-card-title', [_c('h3', [_vm._v("Feedback")]), _vm._v(" "), _c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "loading": _vm.loading.pdf,
      "disabled": _vm.pdfBtnDisabled || _vm.loading.pdf,
      "outline": "",
      "color": "blue"
    },
    on: {
      "click": _vm.downloadFeedback
    }
  }, [_vm._v("PDF\n        "), _c('v-icon', [_vm._v("list")])], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "md2": ""
    }
  }, [_c('v-menu', {
    model: {
      value: (_vm.menuDateStart),
      callback: function($$v) {
        _vm.menuDateStart = $$v
      },
      expression: "menuDateStart"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Visitation date",
      "prepend-icon": "event",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.feedbackForm.dateStart),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "dateStart", $$v)
      },
      expression: "feedbackForm.dateStart"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "reactive": ""
    },
    model: {
      value: (_vm.feedbackForm.dateStart),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "dateStart", $$v)
      },
      expression: "feedbackForm.dateStart"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "md2": "",
      "offset-sm1": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Visitation time",
      "prepend-icon": "alarm",
      "value": "12:30:00",
      "type": "time"
    },
    model: {
      value: (_vm.feedbackForm.timeStart),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "timeStart", $$v)
      },
      expression: "feedbackForm.timeStart"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-combobox', {
    attrs: {
      "items": _vm.allUsers,
      "label": "Briefing by"
    },
    model: {
      value: (_vm.feedbackForm.selectedUser),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "selectedUser", $$v)
      },
      expression: "feedbackForm.selectedUser"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Family assemble time",
      "prepend-icon": "alarm",
      "value": "12:30:00",
      "type": "time"
    },
    model: {
      value: (_vm.feedbackForm.familyAssembleTime),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "familyAssembleTime", $$v)
      },
      expression: "feedbackForm.familyAssembleTime"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "md2": "",
      "offset-sm1": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Funeral service commenced time",
      "prepend-icon": "alarm",
      "value": "12:30:00",
      "type": "time"
    },
    model: {
      value: (_vm.feedbackForm.funeralServiceCommencedTime),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "funeralServiceCommencedTime", $$v)
      },
      expression: "feedbackForm.funeralServiceCommencedTime"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-combobox', {
    attrs: {
      "items": ['lifting of coffin', 'fong ting', 'sa jing'],
      "multiple": "",
      "small-chips": "",
      "label": "Funeral rites"
    },
    model: {
      value: (_vm.feedbackForm.funeralRites),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "funeralRites", $$v)
      },
      expression: "feedbackForm.funeralRites"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Cortege leave time",
      "prepend-icon": "alarm",
      "value": "12:30:00",
      "type": "time"
    },
    model: {
      value: (_vm.feedbackForm.cortegeLeaveTime),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "cortegeLeaveTime", $$v)
      },
      expression: "feedbackForm.cortegeLeaveTime"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm8": "",
      "md10": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Church location"
    },
    model: {
      value: (_vm.feedbackForm.churchLocation),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "churchLocation", $$v)
      },
      expression: "feedbackForm.churchLocation"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm2": "",
      "offset-sm1": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Church mass at",
      "prepend-icon": "alarm",
      "value": "12:30:00",
      "type": "time"
    },
    model: {
      value: (_vm.feedbackForm.churchMassAt),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "churchMassAt", $$v)
      },
      expression: "feedbackForm.churchMassAt"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Driving pass"
    },
    model: {
      value: (_vm.feedbackForm.drivingPass),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "drivingPass", $$v)
      },
      expression: "feedbackForm.drivingPass"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Cremation location"
    },
    model: {
      value: (_vm.feedbackForm.cremationLocation),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "cremationLocation", $$v)
      },
      expression: "feedbackForm.cremationLocation"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm2": "",
      "offset-sm1": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Cremation time",
      "prepend-icon": "alarm",
      "value": "12:30:00",
      "type": "time"
    },
    model: {
      value: (_vm.feedbackForm.cremationTime),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "cremationTime", $$v)
      },
      expression: "feedbackForm.cremationTime"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Post funeral send to"
    },
    model: {
      value: (_vm.feedbackForm.postFuneralSendTo),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "postFuneralSendTo", $$v)
      },
      expression: "feedbackForm.postFuneralSendTo"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Ash collection"
    },
    model: {
      value: (_vm.feedbackForm.ashCollection),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "ashCollection", $$v)
      },
      expression: "feedbackForm.ashCollection"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "md2": "",
      "offset-sm0": "",
      "offset-md1": ""
    }
  }, [_c('v-menu', {
    model: {
      value: (_vm.menuAshCollectionDate),
      callback: function($$v) {
        _vm.menuAshCollectionDate = $$v
      },
      expression: "menuAshCollectionDate"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Ash collection date",
      "prepend-icon": "event",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.feedbackForm.ashCollectionDate),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "ashCollectionDate", $$v)
      },
      expression: "feedbackForm.ashCollectionDate"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "reactive": ""
    },
    model: {
      value: (_vm.feedbackForm.ashCollectionDate),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "ashCollectionDate", $$v)
      },
      expression: "feedbackForm.ashCollectionDate"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "md2": "",
      "offset-sm0": "",
      "offset-md1": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Ash collection time",
      "prepend-icon": "alarm",
      "value": "12:30:00",
      "type": "time"
    },
    model: {
      value: (_vm.feedbackForm.ashCollectionTime),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "ashCollectionTime", $$v)
      },
      expression: "feedbackForm.ashCollectionTime"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Send ash to"
    },
    model: {
      value: (_vm.feedbackForm.sendAshTo),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "sendAshTo", $$v)
      },
      expression: "feedbackForm.sendAshTo"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "md2": "",
      "offset-sm0": "",
      "offset-md1": ""
    }
  }, [_c('v-menu', {
    model: {
      value: (_vm.menuSendAshToDate),
      callback: function($$v) {
        _vm.menuSendAshToDate = $$v
      },
      expression: "menuSendAshToDate"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Send ash to date",
      "prepend-icon": "event",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.feedbackForm.sendAshToDate),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "sendAshToDate", $$v)
      },
      expression: "feedbackForm.sendAshToDate"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "reactive": ""
    },
    model: {
      value: (_vm.feedbackForm.sendAshToDate),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "sendAshToDate", $$v)
      },
      expression: "feedbackForm.sendAshToDate"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "md2": "",
      "offset-sm0": "",
      "offset-md1": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Send ash to time",
      "prepend-icon": "alarm",
      "value": "12:30:00",
      "type": "time"
    },
    model: {
      value: (_vm.feedbackForm.sendAshToTime),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "sendAshToTime", $$v)
      },
      expression: "feedbackForm.sendAshToTime"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Sea burial at"
    },
    model: {
      value: (_vm.feedbackForm.seaBurialAt),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "seaBurialAt", $$v)
      },
      expression: "feedbackForm.seaBurialAt"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "md2": "",
      "offset-sm0": "",
      "offset-md1": ""
    }
  }, [_c('v-menu', {
    model: {
      value: (_vm.menuSeaBurialAtDate),
      callback: function($$v) {
        _vm.menuSeaBurialAtDate = $$v
      },
      expression: "menuSeaBurialAtDate"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Sea burial at date",
      "prepend-icon": "event",
      "readonly": ""
    },
    slot: "activator",
    model: {
      value: (_vm.feedbackForm.seaBurialAtDate),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "seaBurialAtDate", $$v)
      },
      expression: "feedbackForm.seaBurialAtDate"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "reactive": ""
    },
    model: {
      value: (_vm.feedbackForm.seaBurialAtDate),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "seaBurialAtDate", $$v)
      },
      expression: "feedbackForm.seaBurialAtDate"
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "md2": "",
      "offset-sm0": "",
      "offset-md1": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Sea burial at time",
      "prepend-icon": "alarm",
      "value": "12:30:00",
      "type": "time"
    },
    model: {
      value: (_vm.feedbackForm.seaBurialAtTime),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "seaBurialAtTime", $$v)
      },
      expression: "feedbackForm.seaBurialAtTime"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm4": "",
      "md2": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Dismantling of the tentage will be after",
      "prepend-icon": "alarm",
      "value": "12:30:00",
      "type": "time"
    },
    model: {
      value: (_vm.feedbackForm.tentageAfter),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "tentageAfter", $$v)
      },
      expression: "feedbackForm.tentageAfter"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "sm8": "",
      "md10": ""
    }
  }), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-label', {
    attrs: {
      "gray": ""
    }
  }, [_vm._v("Satisfied with set up?")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.feedbackForm.satisfiedWithSetUp),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "satisfiedWithSetUp", $$v)
      },
      expression: "feedbackForm.satisfiedWithSetUp"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Yes",
      "value": true
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "No",
      "value": false
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm9": "",
      "offset-sm0": "",
      "offset-md1": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Why?"
    },
    model: {
      value: (_vm.feedbackForm.satisfiedWithSetUpWhy),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "satisfiedWithSetUpWhy", $$v)
      },
      expression: "feedbackForm.satisfiedWithSetUpWhy"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-label', {
    attrs: {
      "gray": ""
    }
  }, [_vm._v("Satisfied with catering?")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.feedbackForm.satisfiedWithCatering),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "satisfiedWithCatering", $$v)
      },
      expression: "feedbackForm.satisfiedWithCatering"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Yes",
      "value": true
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "No",
      "value": false
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm9": "",
      "offset-sm0": "",
      "offset-md1": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Why?"
    },
    model: {
      value: (_vm.feedbackForm.satisfiedWithCateringWhy),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "satisfiedWithCateringWhy", $$v)
      },
      expression: "feedbackForm.satisfiedWithCateringWhy"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-label', {
    attrs: {
      "gray": ""
    }
  }, [_vm._v("Satisfied with night service?")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.feedbackForm.satisfiedWithNightService),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "satisfiedWithNightService", $$v)
      },
      expression: "feedbackForm.satisfiedWithNightService"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Yes",
      "value": true
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "No",
      "value": false
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm9": "",
      "offset-sm0": "",
      "offset-md1": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Why?"
    },
    model: {
      value: (_vm.feedbackForm.satisfiedWithNightServiceWhy),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "satisfiedWithNightServiceWhy", $$v)
      },
      expression: "feedbackForm.satisfiedWithNightServiceWhy"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-label', {
    attrs: {
      "gray": ""
    }
  }, [_vm._v("Satisfied with information provided?")])], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm3": "",
      "md2": ""
    }
  }, [_c('v-radio-group', {
    attrs: {
      "row": ""
    },
    model: {
      value: (_vm.feedbackForm.satisfiedWithInformationProvided),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "satisfiedWithInformationProvided", $$v)
      },
      expression: "feedbackForm.satisfiedWithInformationProvided"
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "Yes",
      "value": true
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "No",
      "value": false
    }
  })], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm9": "",
      "offset-sm0": "",
      "offset-md1": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Why?"
    },
    model: {
      value: (_vm.feedbackForm.satisfiedWithInformationProvidedWhy),
      callback: function($$v) {
        _vm.$set(_vm.feedbackForm, "satisfiedWithInformationProvidedWhy", $$v)
      },
      expression: "feedbackForm.satisfiedWithInformationProvidedWhy"
    }
  })], 1)], 1)], 1), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-title', [_c('h3', [_vm._v("Client Agreement Sign")])]), _vm._v(" "), _c('v-divider'), _vm._v(" "), _c('v-card-text', [_c('v-tooltip', {
    attrs: {
      "top": ""
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "flat": "",
      "icon": ""
    },
    on: {
      "click": _vm.clearSignature
    },
    slot: "activator"
  }, [_c('v-icon', {
    attrs: {
      "color": "red"
    }
  }, [_vm._v("undo")])], 1), _vm._v("\n        Clear signature\n      ")], 1), _vm._v(" "), _c('div', {
    staticClass: "sign-pad",
    attrs: {
      "id": "signature-pad"
    }
  }, [_c('VueSignaturePad', {
    ref: "signaturePad",
    attrs: {
      "height": "250px",
      "width": "500px"
    }
  })], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "block": "",
      "loading": _vm.loading.signBtn,
      "disabled": _vm.loading.signBtn
    },
    on: {
      "click": _vm.saveFeedback
    }
  }, [_vm._v("\n        Save feedback\n      ")]), _vm._v(" "), _c('v-snackbar', {
    attrs: {
      "bottom": "",
      "color": "success",
      "multi-line": "",
      "timeout": 2000
    },
    model: {
      value: (_vm.snackbar),
      callback: function($$v) {
        _vm.snackbar = $$v
      },
      expression: "snackbar"
    }
  }, [_vm._v("Feedback saved!")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06054dba","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/CaseAgreementFeedback.vue
// module id = 927
// module chunks = 1